import { AbsenceAccountingSalaryConfig, BonusAccountingSalaryConfig } from "../model";
export const absenceAccountingSalaryConfigPropsWithWageType = [
    "vacation",
    "compDay",
    "sick",
    "childSick",
    "sickInKUG",
];
export const bonusAccountingSalaryConfigPropsWithWageType = [
    "night1",
    "night2",
    "sunday",
    "holiday",
    "special",
];
export const accountingSalaryConfigPropsWithWageType = [
    "workHourly",
    "workMonthly",
    "workHourlyDays",
    "workMonthlyDays",
    "absenceHourly",
    "absenceHourlyDays",
    "absenceMonthly",
    "absenceMonthlyDays",
    "bonusTaxFree",
    "bonusTaxed",
    "mealsValue",
    "mealsBreakfast",
    "mealsLunch",
    "mealsDinner",
    "commission",
    "bonusAdvance",
    "payAdvance",
    "salary",
];
export function updateAbsenceWageTypeNumber(config, oldNumber, newNumber) {
    const updated = {};
    absenceAccountingSalaryConfigPropsWithWageType.forEach((prop) => {
        if (config[prop] === oldNumber) {
            updated[prop] = newNumber;
        }
    });
    Object.assign(config, updated);
}
export function removeAbsenceWageTypeNumber(config, wageTypeNumber) {
    updateAbsenceWageTypeNumber(config, wageTypeNumber, "");
}
export function updateBonusWageTypeNumber(config, oldNumber, newNumber) {
    const updated = {};
    bonusAccountingSalaryConfigPropsWithWageType.forEach((prop) => {
        if (config[prop] === oldNumber) {
            updated[prop] = newNumber;
        }
    });
    Object.assign(config, updated);
}
export function removeBonusWageTypeNumber(config, wageTypeNumber) {
    updateBonusWageTypeNumber(config, wageTypeNumber, "");
}
export function updateAccountingSalaryConfigWageTypeNumber(config, oldNumber, newNumber) {
    const updated = {};
    accountingSalaryConfigPropsWithWageType.forEach((prop) => {
        if (config[prop] === oldNumber) {
            updated[prop] = newNumber;
        }
        // handle bonus and absence configs
        else if (config[prop] instanceof AbsenceAccountingSalaryConfig ||
            config[prop] instanceof BonusAccountingSalaryConfig) {
            if (config[prop] instanceof AbsenceAccountingSalaryConfig) {
                updateAbsenceWageTypeNumber(config[prop], oldNumber, newNumber);
            }
            else if (config[prop] instanceof BonusAccountingSalaryConfig) {
                updateBonusWageTypeNumber(config[prop], oldNumber, newNumber);
            }
        }
    });
    // handle benefits
    if (config.benefits) {
        config.benefits.forEach((benefit) => {
            if (benefit.wageTypeNumber === oldNumber) {
                benefit.wageTypeNumber = newNumber;
            }
        });
    }
    if (config.bonuses) {
        config.bonuses.forEach((bonus) => {
            if (bonus.taxed === oldNumber) {
                bonus.taxed = newNumber;
            }
            if (bonus.taxFree === oldNumber) {
                bonus.taxFree = newNumber;
            }
            if (bonus.taxedVacation === oldNumber) {
                bonus.taxedVacation = newNumber;
            }
            if (bonus.taxedSick === oldNumber) {
                bonus.taxedSick = newNumber;
            }
        });
    }
    Object.assign(config, updated);
}
export function removeAccountingSalaryConfigWageTypeNumber(config, wageTypeNumber) {
    updateAccountingSalaryConfigWageTypeNumber(config, wageTypeNumber, "");
}
//# sourceMappingURL=wage-type.util.js.map